import React from 'react'
import { Link } from 'react-router-dom'

export const Banner = () => {
    return (
        <div>
            <div class="main-banner wow fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-6 align-self-center">
                                    <div class="left-content show-up header-text wow fadeInLeft" data-wow-duration="1s" data-wow-delay="1s">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <h6>Digital Marketing  Agency </h6>
                                                <h2>We Boost Your Business</h2>
                                                <p className='fw-normal'>Our highly tailored advertising services grow your brand
                                                    Get in touch with us to get your business in top ranking.</p>
                                            </div>
                                            <div class="col-lg-12">
                                                <div class="border-first-button scroll-to-section">
                                                    <Link to="/contact">Send Proposal</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="right-image wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.5s">
                                        <img src="assets/images/slider-dec.png" alt="Frishtey Media" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
